import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { PathPickPopularBrandsRequestParams } from "@/features/pathpick/features/search-products/types/request-params";
import { PathPickPopularBrandsResponse } from "@/features/pathpick/features/search-products/types/response";
import { PathPickFilterInfoResponse } from "@/features/pathpick/types/response";

const url = {
  getPathPickPopularBrands: (companyId: number) =>
    `/buyers/${companyId}/pathpick/popular-brands`,
  getPathPickFilterInfo: (companyId: number) =>
    `/buyers/${companyId}/pathpick/filter-info`,
};

export const pathPickSearchProductsQueryApi = {
  getPathPickPopularBrands: async (
    companyId: number,
    params?: PathPickPopularBrandsRequestParams
  ) => {
    const { data } = await axiosClient.get<PathPickPopularBrandsResponse>(
      url.getPathPickPopularBrands(companyId),
      { params: params ? toSnakeKeyObject(params) : undefined }
    );
    return data;
  },
  getPathPickFilterInfo: async (companyId: number) => {
    const { data } = await axiosClient.get<PathPickFilterInfoResponse>(
      url.getPathPickFilterInfo(companyId)
    );
    return data;
  },
};
